import { captureException } from '@sentry/react';
import { useCallback, useState } from 'react';

import { segmentIdentify } from 'src/shared/telemetry';

const useSegment = () => {
  const [loading, setLoading] = useState(false);

  const identify = useCallback(
    async (...args: Parameters<typeof segmentIdentify>) => {
      try {
        setLoading(true);

        await segmentIdentify(...args);
      } catch (error) {
        captureException(error);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { identify, loading };
};

export { useSegment };
